import React from 'react';
import { ModalHeader } from '../../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../../CommonComponents/OPL/Button/Button';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { Link } from '../../../../../../../CommonComponents/OPL/Link/Link';

interface Props {
  onClose: () => void;
  onAccept: () => void;
}

export const TermsModal = ({ onClose, onAccept }: Props) => {
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'PdfReaderAI-terms--modal-header' }}
    >
      <ModalHeader as="h2" id="PdfReaderAI-terms--modal-header">
        Orion AI PDF Reader (Beta) Agreement
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Text as="p" fontSize="body" lineHeight="body" fontWeight={400} mb="24">
          BY ENABLING THE ORION AI PDF READER BETA FUNCTIONALITY YOU ACKNOWLEGE YOU HAVE READ AND
          AGREE TO THE TERMS AND CONDITIONS SET FORTH IN THE AI ADDENDUM AVAILABLE AT{' '}
          <Link href="https://orion.com/ai-addendum">https://orion.com/ai-addendum</Link> AND TO
          ABIDE BY THE ACCEPTABLE USE POLICY AVAILABLE AT{' '}
          <Link href="https://orion.com/ai-services-acceptable-use-policy">
            https://orion.com/ai-services-acceptable-use-policy
          </Link>
          . YOUR CONTINUED ACCESS TO THE ORION AI PDF READER BETA FUNCTIONALITY IS CONSIDERED ACCESS
          TO BETA AI SERVICES, AS SET FORTH IN THE AI ADDENDUM.
        </Text>
      </ModalBody>

      <ModalFooter hasBorder>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button ml="8" onClick={onAccept}>
          I Accept
        </Button>
      </ModalFooter>
    </Modal>
  );
};
